import styled from 'styled-components';
import React, {FC} from 'react';

import {commonButtonStyle} from '.';
import {Icon} from '../../../../molecules/icon';
import {StyledLeftMenuButton} from '../headerMenu';
import {hasHref, HeaderMenuProps} from '../headerMenuTypes';
import {HeaderSubMenu} from '../headerSubMenu';
import {getHeaderColor} from '../headerUtils';

interface HeaderLeftNavProps {
  leftNav: HeaderMenuProps['leftNav'];
  isHeaderHighlighted?: boolean;
  isScrolled: boolean;
  locationPath: string;
}
const StyledLeftMenuButtonText = styled.span`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  margin-left: 4px;
`;

export const HeaderLeftNav: FC<HeaderLeftNavProps> = props => (
  <>
    {props.leftNav.map(item => {
      if (hasHref(item))
        return (
          <StyledLeftMenuButton
            backgroundColor={
              getHeaderColor({
                isHighlighted: props.isHeaderHighlighted,
                isScrolled: props.isScrolled,
                isLinkActive: item.href === props.locationPath
              }).link
            }
            $css={commonButtonStyle}
            href={item.href}
            key={item.name}
          >
            {item.name}
          </StyledLeftMenuButton>
        );
      const subItemHrefs = item.subMenu.items.map(subItem => subItem.href).filter(Boolean);

      return (
        <StyledLeftMenuButton
          as="span"
          $css={commonButtonStyle}
          backgroundColor={
            getHeaderColor({
              isHighlighted: props.isHeaderHighlighted,
              isScrolled: props.isScrolled,
              isLinkActive: subItemHrefs.includes(props.locationPath)
            }).link
          }
          isDropdown
          key={item.name}
        >
          <StyledLeftMenuButtonText>
            {item.name}
            <StyledIcon name="chevronDown" />
          </StyledLeftMenuButtonText>
          <HeaderSubMenu {...item} locationPath={props.locationPath} />
        </StyledLeftMenuButton>
      );
    })}
  </>
);
